import {
    ICourse,
    IImportCourse,
    IGroupConcept,
    ICourseGroup,
    ICourseGC,
    IConceptData, IInstituteList, IDepartmentList
} from "./StateInterfaces";

export interface IInitialState {
    instructorCoursesMap: Map<number, ICourse>;
    instructorImportCoursesList: IImportCourse[];
    // instructorActiveCourse: number;
    studentCoursesMap: Map<number, ICourse>;
    // studentActiveCourse: number;
    publicCoursesMap: Map<number, ICourse>;
    paginationInfo: any;

    studentCourseGroupsMap: Map<number, Array<ICourseGroup>>;
    studentGroupConceptsMap: Map<number, Array<IGroupConcept>>;

    instructorCourseGC: ICourseGC;

    instructorConceptDataMap: Map<number, IConceptData>;
    studentConceptDataMap: Map<number, IConceptData>;
    instituteList: any;
};

export default <IInitialState>{
    instructorCoursesMap: new Map<number, ICourse>(),
    instructorImportCoursesList: [],
    studentCoursesMap: new Map<number, ICourse>(),
    publicCoursesMap: new Map<number, ICourse>(),
    instituteList: new Map<number, IInstituteList>(),
    departmentList: new Map<number, IDepartmentList>(),
    paginationInfo: null,

    studentCourseGroupsMap: new Map<number, Array<ICourseGroup>>(),
    studentGroupConceptsMap: new Map<number, Array<IGroupConcept>>(),
    instructorCourseGC: {
        instructorCourseGroupsMap: new Map<number, Array<ICourseGroup>>(),
        instructorGroupConceptsMap: new Map<number, Array<IGroupConcept>>()
    },
    instructorConceptDataMap: new Map<number, IConceptData>(),
    studentConceptDataMap: new Map<number, IConceptData>()
};
